import { Pipe, PipeTransform } from "@angular/core";
import { Node, UUID } from "../../_model";
import { DataProvider } from "../services/data/data";

@Pipe({
	name: "node",
	standalone: true
})
export class NodePipe implements PipeTransform {

	constructor(private data: DataProvider) {
	}

	async transform(id: UUID): Promise<Node> {
		return this.data.getNode(id);

	}

}
